import React from "react";

import Item from "../Item";

import jcsp from "../../assets/img2/jcsp2.png";

import lmjs from "../../assets/img2/lmjs2.png";
import gdjc from "../../assets/img2/gdjc2.png";
import img100 from "../../assets/img2/100.png";
import img10 from "../../assets/img2/10.png";

import "./index.scss";

import Column from "../Column";

import useStore from "../../store";

import { observer } from "mobx-react-lite";

const List = (props) => {
  const { listStore } = useStore();

  const listData = listStore.getList();

  return (
    <div className="List">
      <div className="Bg">
        <div className="Bt">
          <img src={jcsp} alt="精彩视频" />
        </div>
        <div className="ItemBox">
          {listData.map((item) => (
            <Item
              imgSrc={item.img}
              title={item.title}
              link={item.link}
              src={item.src}
              id={item.id}
              key={item.id}
              shade={item.shade}
              onPortal={props.onPortal}
              onTemp={props.onTemp}
              onWheel={props.onWheel}
            />
          ))}
        </div>
        <div className="Bt">
          <img src={lmjs} alt="栏目介绍" />
        </div>
        <Column />
        <div className="Bt">
          <img src={gdjc} alt="更多精彩" />
        </div>
        <div className="ItemBox2">
          <div className="imgBox">
            <a
              href="http://sike.news.cn/hot/100year/index.html"
              rel="noreferrer"
              target="_blank"
            >
              <img src={img100} alt="" />
            </a>
          </div>
          <div className="imgBox">
            <a
              href="https://liveun.news.cn/2022/dangxiao/index.html"
              rel="noreferrer"
              target="_blank"
            >
              <img src={img10} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(List);
